import AcfHelper from "../../_acf";

const DetailsElts = {};

DetailsElts.blockName = "event-planning";

const selector = `[autoclose-details]`;

let autocloseDetails = null;

const getAutocloseDetails = () => {
    if (!autocloseDetails) {
        autocloseDetails = document.querySelectorAll(selector);
    }

    return autocloseDetails;
};

const closeAllSimilar = (elt) => {
    getAutocloseDetails().forEach(detailsElt => {
        if (detailsElt !== elt && detailsElt.parentNode === elt.parentNode) {
            closeElt(detailsElt);
        }
    });
};

const isOpened = (elt) => {
    return elt.hasAttribute('open');
};

const closeElt = (elt) => {
    elt.removeAttribute('open');
};

DetailsElts.init = () => {
    AcfHelper.handleInit(DetailsElts.blockName, () => {
        getAutocloseDetails().forEach(detailsElt => {
            detailsElt.addEventListener('toggle', (e) => {
                if (isOpened(e.target)) {
                    closeAllSimilar(e.target);
                }
            })
        });
    });
};

DetailsElts.init();

export default DetailsElts;
